module.exports = __webpack_public_path__ + "img/chainmap.fd789e25.png";